import React from 'react'
import {
  LoaderSwitcher,
  MerchantCategoriesLoader,
  MerchantLocationsLoader,
  LoyaltyOverviewLoader,
  LoyaltyCardsLoader
} from 'router/Loaders'
import Loyalty from 'components/Loyalty'
import {
  LoyaltyOverviewContext,
  SetupLoyaltyOverview
} from 'hooks/useGlobalContext/useLoyaltyOverview'
import {
  LoyaltyCardsContext,
  SetupLoyaltyCards
} from 'hooks/useGlobalContext/useLoyaltyCards'

// LoyaltyOverviewContext/LoyaltyCardsContext are mounted here rather than
// in the app-wide GlobalContext, since their state only needs to survive
// navigation between the Loyalty tabs — see doc/ARCHITECTURE.md §6.1 ("or
// in the shared layout wrapping just the routes that need something
// narrower"). The Loaders sit above <Tabs> (in Loyalty/index.tsx), which
// destroyInactiveTabPane unmounts on every switch, so this placement is
// what survives that instead of refetching each time.
export const LoyaltyWrapper = () => {
  return (
    <LoyaltyOverviewContext.Provider value={SetupLoyaltyOverview()}>
      <LoyaltyCardsContext.Provider value={SetupLoyaltyCards()}>
        <MerchantCategoriesLoader>
          {(isParentLoaded) => (
            <MerchantLocationsLoader isParentLoaded={isParentLoaded}>
              {(isParentLoaded) => (
                <LoyaltyOverviewLoader isParentLoaded={isParentLoaded}>
                  {(isParentLoaded) => (
                    <LoyaltyCardsLoader isParentLoaded={isParentLoaded}>
                      {(isParentLoaded) => (
                        <LoaderSwitcher isParentLoaded={isParentLoaded}>
                          <Loyalty />
                        </LoaderSwitcher>
                      )}
                    </LoyaltyCardsLoader>
                  )}
                </LoyaltyOverviewLoader>
              )}
            </MerchantLocationsLoader>
          )}
        </MerchantCategoriesLoader>
      </LoyaltyCardsContext.Provider>
    </LoyaltyOverviewContext.Provider>
  )
}
